app.service('analysisService', function () { 


})